import { Invoice } from "./../../models/invoice.model";
import { AxiosResponse } from "axios";
import talentApi from "./talent-api-config";
import { parseISO } from "date-fns";

class CompanyApi {
  async fetchLastInvoice(): Promise<AxiosResponse<Invoice>> {
    const response = await talentApi.get<Invoice>(`/talent/invoice/last/`);

    if (response.data?.due) {
      response.data.due = parseISO(response.data.due.toString());
    }

    return response;
  }

  async fetchRecruiters(companyId: string): Promise<AxiosResponse<any>> {
    return await talentApi.get<any>(`/talent/recruiters/${companyId}/`);
  }

  async updateUserCompany(
    companyName: string,
    companySize: string,
    reason: string,
  ): Promise<AxiosResponse<any>> {
    return await talentApi.post(`/register/talent/company/`, {
      company: {
        name: companyName,
        employees_range: companySize,
      },
      reason: reason,
    });
  }
}

export const companyApi = new CompanyApi();
